var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4657_837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1998 14.9998C25.1998 20.6331 20.6331 25.1998 14.9998 25.1998C9.36652 25.1998 4.7998 20.6331 4.7998 14.9998C4.7998 9.36652 9.36652 4.7998 14.9998 4.7998C20.6331 4.7998 25.1998 9.36652 25.1998 14.9998Z",
    fill: "#F15C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4001 15.0001C23.4001 19.6393 19.6393 23.4001 15.0001 23.4001C10.3609 23.4001 6.6001 19.6393 6.6001 15.0001C6.6001 10.3609 10.3609 6.6001 15.0001 6.6001C19.6393 6.6001 23.4001 10.3609 23.4001 15.0001Z",
    fill: "#F36D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 15C21 18.3137 18.3137 21 15 21C11.6863 21 9 18.3137 9 15C9 11.6863 11.6863 9 15 9C18.3137 9 21 11.6863 21 15Z",
    fill: "#F5844E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9072 6.17773L16.6236 14.128L22.7855 17.6848L15.7163 16.8809L12.0214 24.0364L13.305 16.0862L7.14307 12.5295L14.2123 13.3333L17.9072 6.17773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0483 9.48975L15.2806 13.0069L19.8704 12.3246L16.5162 15.531L17.3114 20.2411L14.0791 16.7239L9.48926 17.4064L12.8435 14.2L12.0483 9.48975Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 27.6C21.9588 27.6 27.6 21.9588 27.6 15C27.6 8.0412 21.9588 2.4 15 2.4C8.0412 2.4 2.4 8.0412 2.4 15C2.4 21.9588 8.0412 27.6 15 27.6ZM15 30C23.2843 30 30 23.2843 30 15C30 6.71574 23.2843 0 15 0C6.71574 0 0 6.71574 0 15C0 23.2843 6.71574 30 15 30Z",
    fill: "#58585A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4657_837"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.2ecdf9ee0dc28c1f53a99c5e099aa490.svg";
export { ForwardRef as ReactComponent };